import Cookie from "../../js/lib/cookie";
if (Cookie.get("agree") != "agree") {
  $(".js-cookies").removeClass("is-hide");
}
console.log(Cookie.get("agree"));
$(".js-cookies-agree").on("click", function () {
  $(".js-cookies").addClass("is-hide");
  Cookie.set("agree", "agree");
});
